import { useState } from 'react';
import { useTheme } from 'styled-components';

import { Button, Typography } from '../../../designComponents';
import { useResponsive } from '../../../hooks/useResponsive';
import PlansCard from './PlansCard';
import { ContainerStyled, PricingPlansStyled } from './styled';
import WhatYouGet from './WhatYouGet';

const btnData = [
  {
    label: 'Monthly',
  },
  {
    label: 'Yearly',
  },
];
const PricingPlans = () => {
  const theme = useTheme();
  const [clickedIndex, setClickedIndex] = useState<number>(0);
  const handlePlansClick = (id: number) => {
    setClickedIndex(id);
  };
  const { isTablet } = useResponsive();

  return (
    <>
      <PricingPlansStyled>
        <ContainerStyled>
          <div className="headings">
            <div className="main-text">
              <Typography
                variant="heading"
                style={{
                  color: theme.colors.landingSecondaryText,
                  fontWeight: 600,
                }}
                className="heading"
              >
                Tailored{' '}
                <span style={{ color: theme.colors.primary }}>
                  Pricing Plans
                </span>
                : Find the Perfect Fit for Your Project
              </Typography>
              <Typography style={{ fontWeight: 500 }} className="text">
                Select a package that aligns with your needs and preferences.
              </Typography>
            </div>
            <div className="btns-text">
              <div className="btns">
                {btnData.map((data, idx) => (
                  <Button
                    className="btn"
                    key={idx}
                    onClick={() => handlePlansClick(idx)}
                    style={{
                      backgroundColor:
                        clickedIndex === idx ? theme.colors.primary : 'white',
                      color:
                        clickedIndex === idx
                          ? theme.colors.white
                          : theme.colors.border,
                      border:
                        clickedIndex !== idx
                          ? `2px solid ${theme.colors.border}`
                          : '',
                    }}
                  >
                    {data.label}
                  </Button>
                ))}
              </div>
              <Typography style={{ fontWeight: 500 }}>
                Save Up to{' '}
                <span
                  style={{
                    color: theme.colors.munsellBlue.strong,
                    fontWeight: 600,
                    fontSize: '36px',
                    lineHeight: '43.57px',
                  }}
                >
                  20%
                </span>{' '}
                yearly
              </Typography>
            </div>
          </div>
          {!isTablet ? (
            <div className="card-container">
              <PlansCard label="Standard" price="20.00" isRecommend />
              <PlansCard label="Professional" price="15.00" />
              <PlansCard label="Enterprise" price="15.00" />
            </div>
          ) : (
            <div className="card-container">
              <PlansCard label="Professional" price="15.00" />
              <PlansCard label="Standard" price="20.00" isRecommend />
              <PlansCard label="Enterprise" price="15.00" />
            </div>
          )}
        </ContainerStyled>
      </PricingPlansStyled>
      <WhatYouGet></WhatYouGet>
    </>
  );
};

export default PricingPlans;
